// Circle of Light cards carousel
// https://trevorproject.atlassian.net/browse/WEB-109
/* global trevorWP */
import Swiper from 'swiper';

document.querySelectorAll('.circle-of-light .swiper').forEach((el) => {
	let wrapperEl = el.querySelector('.swiper-wrapper');

	// Check for 4+ items before intiializing the carousel
	if (wrapperEl.children.length < 4) {
		return false;
	}

	// Swiper docs https://swiperjs.com/swiper-api#parameters
	let swiper = new Swiper(el, {
		centerSlides:  false,// active one in center
		// centerInsufficientSlides: true,
		slidesPerGroup: 1,
		slidesPerView: 1,
		spaceBetween: 28,
	  speed: 400,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			bulletElement: 'button',
		},
		breakpoints: {
			1024: {
				slidesPerView: 'auto',
			},
			// 1366: {
			// 	spaceBetween: 28,
			// 	slidesPerView: 1,
			// 	slidesPerGroup: 1,
			// },
		},
	});
});
